import { useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

// appt: appointment being edited; finishing: true when confirming before marking "Concluído"
export const TollDialog = ({ appt, finishing, onClose, onDone }) => {
  const [value, setValue] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => { setValue(appt ? String(appt.toll || 0) : ""); }, [appt]);

  const save = async () => {
    const n = Number(String(value).replace(",", "."));
    if (isNaN(n) || n < 0) { toast.error("Informe um valor válido"); return; }
    setSaving(true);
    try {
      if (Number(appt.toll || 0) !== n || !appt.asaas_payment_id) await api.patch(`/appointments/${appt.id}/toll`, { toll: n });
    } catch (e) { toast.error(errMsg(e, "Falha ao salvar pedágio")); setSaving(false); return; }
    try {
      if (finishing) await api.patch(`/appointments/${appt.id}/status`, { status: "completed" });
      toast.success(finishing ? "Atendimento finalizado" : "Pedágio atualizado");
      onDone();
    } catch (e) { toast.error(errMsg(e, "Pedágio salvo, mas falhou ao concluir o atendimento")); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={!!appt} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-sm" data-testid="dialog-toll">
        <DialogHeader>
          <DialogTitle>{finishing ? "Finalizar atendimento" : "Pedágio do atendimento"}</DialogTitle>
          <DialogDescription>
            {appt?.toll_auto ? "Valor calculado automaticamente pela rota. Ajuste se necessário." : "Informe o valor total de pedágio (ida + volta). Use 0 se não houve."}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <Label>Pedágio (R$)</Label>
          <Input data-testid="input-toll" type="number" min="0" step="0.01" inputMode="decimal" value={value} onChange={(e) => setValue(e.target.value)} autoFocus />
          <div className="text-xs text-muted-foreground">O valor é somado ao total cobrado do cliente e não entra na comissão.</div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button data-testid="btn-save-toll" onClick={save} disabled={saving}>{finishing ? "Salvar e concluir" : "Salvar"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
